"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUnreadCountNotificationsByCategory = exports.setNotificationsEntititesToReadByCategory = exports.setNotificationsByCategory = exports.setNotifications = exports.setNotificationCategory = exports.setLoadingNotificationsByCategory = exports.setCountNotificationsByCategory = exports.setAllUnreadCountNotifications = exports.requestPatchNotifications = exports.requestNotificationCount = exports.requestMarkNotificationsAsRead = exports.requestGetNotifications = exports.requestGetNextNotifications = exports.removeNotificationFromEntities = exports.addNotificationsByCategory = exports.addNewNotificationByCategory = exports.addNewNotification = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var addNewNotification = _notification => ({
  type: types.ADD_NEW_NOTIFICATION,
  _notification
});
exports.addNewNotification = addNewNotification;
var addNewNotificationByCategory = (category, _notification) => ({
  type: types.ADD_NEW_NOTIFICATION_BY_CATEGORY,
  category,
  _notification
});
exports.addNewNotificationByCategory = addNewNotificationByCategory;
var addNotificationsByCategory = (category, _notifications) => ({
  type: types.ADD_NOTIFICATION_BY_CATEGORY,
  category,
  _notifications
});
exports.addNotificationsByCategory = addNotificationsByCategory;
var removeNotificationFromEntities = _notification => ({
  type: types.REMOVE_NOTIFICATION_FROM_ENTITIES,
  _notification
});
exports.removeNotificationFromEntities = removeNotificationFromEntities;
var requestGetNextNotifications = (category, notificationType, read) => ({
  type: types.REQUEST_GET_NEXT_NOTIFICATIONS,
  category,
  notificationType,
  read
});
exports.requestGetNextNotifications = requestGetNextNotifications;
var requestGetNotifications = (category, notificationType, limit, page, ignored, read) => ({
  type: types.REQUEST_GET_NOTIFICATIONS,
  category,
  notificationType,
  limit,
  page,
  ignored,
  read
});
exports.requestGetNotifications = requestGetNotifications;
var requestMarkNotificationsAsRead = (category, notificationType) => ({
  type: types.REQUEST_MARK_NOTIFICATIONS_AS_READ,
  notificationType,
  category
});
exports.requestMarkNotificationsAsRead = requestMarkNotificationsAsRead;
var requestNotificationCount = (ignored, read) => ({
  type: types.REQUEST_NOTIFICATION_COUNT,
  ignored,
  read
});
exports.requestNotificationCount = requestNotificationCount;
var requestPatchNotifications = (_notification, notification) => ({
  type: types.REQUEST_PATCH_NOTIFICATION,
  _notification,
  notification
});
exports.requestPatchNotifications = requestPatchNotifications;
var setAllUnreadCountNotifications = allCount => {
  allCount.quickActions = ((allCount === null || allCount === void 0 ? void 0 : allCount.contact) || 0) + ((allCount === null || allCount === void 0 ? void 0 : allCount.member) || 0);
  return {
    type: types.SET_ALL_UNREAD_NOTIFICATION_COUNT,
    allCount
  };
};
exports.setAllUnreadCountNotifications = setAllUnreadCountNotifications;
var setCountNotificationsByCategory = (category, count) => ({
  type: types.SET_NOTIFICATION_COUNT_BY_CATEGORY,
  category,
  count
});
exports.setCountNotificationsByCategory = setCountNotificationsByCategory;
var setLoadingNotificationsByCategory = (category, loading) => ({
  type: types.SET_LOADING_NOTIFICATION_COUNT,
  category,
  loading
});
exports.setLoadingNotificationsByCategory = setLoadingNotificationsByCategory;
var setNotificationCategory = category => ({
  type: types.SET_NOTIFICATION_CATEGORY,
  category
});
exports.setNotificationCategory = setNotificationCategory;
var setNotifications = _notifications => ({
  type: types.SET_NOTIFICATIONS,
  _notifications
});
exports.setNotifications = setNotifications;
var setNotificationsByCategory = (category, _notifications) => ({
  type: types.SET_NOTIFICATION_BY_CATEGORY,
  category,
  _notifications
});
exports.setNotificationsByCategory = setNotificationsByCategory;
var setNotificationsEntititesToReadByCategory = category => ({
  type: types.SET_NOTIFICATION_TO_READ_BY_CATEGORY,
  category
});
exports.setNotificationsEntititesToReadByCategory = setNotificationsEntititesToReadByCategory;
var setUnreadCountNotificationsByCategory = (category, unreadCount) => ({
  type: types.SET_UNREAD_NOTIFICATION_COUNT,
  category,
  unreadCount
});
exports.setUnreadCountNotificationsByCategory = setUnreadCountNotificationsByCategory;